var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1667 17.6994H26.5833M14.5 20.116C14.5 18.2494 14.5 17.316 14.8633 16.6027C15.1829 15.9755 15.6928 15.4656 16.32 15.146C17.0333 14.7827 17.9667 14.7827 19.8333 14.7827H24.1667C26.0333 14.7827 26.9667 14.7827 27.68 15.146C28.3072 15.4656 28.8171 15.9755 29.1367 16.6027C29.5 17.316 29.5 18.2494 29.5 20.116V24.4494C29.5 26.316 29.5 27.2494 29.1367 27.9627C28.8171 28.5899 28.3072 29.0998 27.68 29.4194C26.9667 29.7827 26.0333 29.7827 24.1667 29.7827H19.8333C17.9667 29.7827 17.0333 29.7827 16.32 29.4194C15.6928 29.0998 15.1829 28.5899 14.8633 27.9627C14.5 27.2494 14.5 26.316 14.5 24.4494V20.116Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8283 22.9919C24.9215 22.6203 24.9405 22.2341 24.8844 21.8551C24.771 21.0899 24.3583 20.401 23.737 19.9401C23.1157 19.4791 22.3367 19.2839 21.5715 19.3972C20.8062 19.5106 20.1173 19.9233 19.6564 20.5446C19.1954 21.1659 19.0002 21.9449 19.1135 22.7101C19.2269 23.4754 19.6397 24.1643 20.2609 24.6252C20.5686 24.8535 20.9182 25.0189 21.2897 25.112C21.6613 25.2052 22.0475 25.2242 22.4265 25.1681C22.8054 25.1119 23.1695 24.9817 23.4981 24.7848C23.8267 24.588 24.1133 24.3283 24.3415 24.0207C24.5698 23.713 24.7352 23.3634 24.8283 22.9919Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram1);
export default __webpack_public_path__ + "static/media/instagram1.c984ede98ab469be505f4d736faddc8b.svg";
export { ForwardRef as ReactComponent };